<ng-container *ngIf="onInit && data?.type != undefined">
    <ng-container [ngSwitch]="data.type">
        <ng-container *ngSwitchCase="popupTypeEnum.cancelCompanySubscriptionPlanConfirmation ">
            <ng-container *ngTemplateOutlet="estimate_confirmation; context : {'data': data}  "></ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="popupTypeEnum.downgradeEstimateConfirmation ">
            <ng-container *ngTemplateOutlet="estimate_confirmation; context : {'data': data}  "></ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="popupTypeEnum.upgradeEstimateConfirmation ">
            <ng-container *ngTemplateOutlet="upgrade_estimate_confirmation; context : {'data': data}  "></ng-container>
        </ng-container>
        <ng-container *ngSwitchCase=" popupTypeEnum.cancelCompanySubscriptionPlanSuccess ">
            <ng-container *ngTemplateOutlet="header; context : {'data': data}  "></ng-container>
        </ng-container>
        <ng-container *ngSwitchCase=" popupTypeEnum.downgradeCompanySubscriptionPlanSuccess  ">
            <ng-container *ngTemplateOutlet="header; context : {'data': data}  "></ng-container>
        </ng-container>
    </ng-container>
</ng-container>

<ng-template #estimate_confirmation let-data= "data" >
    <ng-container *ngTemplateOutlet="header; context : {'data': data}  "></ng-container>
    <div class="" >
       <span class="estimatedCost">Estimated cost: {{data?.estimatedCost | currency: 'USD': 'symbol': '1.2-2'}}</span>
    </div>
</ng-template>
<ng-template #upgrade_estimate_confirmation let-data= "data" >
    <div class="upgradeEstimateConfirmation">
        <div class="mb-3 title">{{data?.title}}</div>
        <div class="current-plan">
            {{data?.planDescription}}
        </div>
        <div class="current-plan-fare">
            <span class="current-plan-amount">{{data?.estimatedCost | currency: 'USD': 'symbol': '1.2-2'}}</span>/<span class="current-plan-billing-cycle">{{data?.billingDays | callbackPipe:callbackNameEnum.getBillingCycle : {passTrueForDayFalseForDaily: true} }}</span>
        </div>
        <div class="overview-left-block-section2">
            <div class="current-plan-description">
                On prorata basis for the remaining billing cycle
            </div>
            <div class="acount-info-calculation d-flex flex-col mt-4">
                <div class="mb-3">Want to know how this amount is calculated?</div>
                <button class="confirm-subscription-dialog-close secondary-button" (click)="openUpgradeDocumentation()">Click for documentation</button>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #header let-data= "data"  >
    <div class="mb-3 title">{{data.title}}</div>
    <p class="subscription-text content">{{data.content}}</p>
</ng-template>



<div class="dialog-box">
    <div class="d-flex justify-end">
        <ng-container *ngFor="let buttonData of data.buttons">
            <button *ngIf="buttonData.type === dialogResultTypeEnum.cancel" (click)="onCloseAccountDialog(buttonData)"
            [ngClass]="buttonData.class">{{buttonData.title}}
            </button>
            <button mat-flat-button *ngIf="buttonData.type !== dialogResultTypeEnum.cancel" color="primary" [ngClass]="buttonData.class"
                (click)="onCloseAccountDialog(buttonData)">{{buttonData.title}}
            </button>
        </ng-container>
    </div>
</div>